import type { FC } from 'react';

import type {
  BulletPointsCategory,
  BulletPointsType,
} from '@/services/bullet-points';

import BulletPointHighlightSpan from './BulletPointHighlightSpan';

type Props =
  | {
      type?: 'api';
      bullet: BulletPointsType;
      text?: never;
      highlight?: never;
    }
  | {
      type: 'manual';
      bullet?: never;
      text: string;
      highlight: {
        text: string;
        category: BulletPointsCategory;
      }[];
    };

const HighlightText: FC<Props> = ({
  bullet,
  highlight = [],
  text = '',
  type = 'api',
}) => {
  const isApiData = type === 'api' && bullet;

  const valuesToHighlight = (isApiData ? bullet.ratings : highlight)
    .map((e) => e)
    .filter((e) => e.text !== '' && ' ');

  const escapeRegExp = (textToModify: string) =>
    textToModify.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const regex = new RegExp(
    `(${valuesToHighlight.map((e) => escapeRegExp(e.text)).join('|')})`,
    'g'
  );
  const parts = (isApiData ? bullet.text : text)
    .split(regex)
    .filter((part) => part?.trim() !== '');

  const findValueToHighlight = (part: string) =>
    valuesToHighlight.find((value) => value.text === part);

  return (
    <>
      {parts.map((part) =>
        findValueToHighlight(part) ? (
          <BulletPointHighlightSpan
            key={part}
            bulletPointsCategory={findValueToHighlight(part)!.category}
          >
            {part}
          </BulletPointHighlightSpan>
        ) : (
          part
        )
      )}
    </>
  );
};

export default HighlightText;
